import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Header } from '../../header';
import { useNotify } from "tailwind-notifications-react";

export const CreateProductPage = () => {
  const navigate = useNavigate();

  const [productName, setProductName] = useState('');
  const [description, setDescription] = useState('');
  const [sku, setSku] = useState('');
  const [price, setPrice] = useState('');
  const [discount, setDiscount] = useState('');
  const [sizes, setSizes] = useState([]);
  const [type, setType] = useState("none");
  const [produced, setProduced] = useState([]);
  const [category, setCategory] = useState([]);
  const [stock, setStock] = useState([]);
  const [weight, setWeight] = useState([]);
  const [images, setImages] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [tags, setTags] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showDots, setShowDots] = useState(false);
  const lastMoveTime = useRef(0);
  const token = localStorage.getItem('token');

  const notify = useNotify();

  useEffect(() => {
    fetchProducts();
    fetchTags();
  }, []);

  const fetchTags = async () => {
    try {
      const response = await fetch("https://api.alyonatestsite.store/api/tags", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      if (!response.ok) {
        throw new Error("Ошибка загрузки данных");
      }
      const data = await response.json();
      setTags(data);
    } catch (err) {
      console.log(err)
    }
  };

  const fetchProducts = async () => {
    try {
      await axios.get('https://api.alyonatestsite.store/api/products');
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const handleTagClick = (tag) => {
    if (selectedTags.some((t) => t.name === tag.name)) {
      setSelectedTags(selectedTags.filter((t) => t.name !== tag.name));
    } else {
      setSelectedTags([...selectedTags, tag]);
    }
  };

  const handleAddProduct = async () => {
    const formData = new FormData();
    formData.append('name', productName);
    formData.append('description', description);
    formData.append('sku', sku);
    formData.append('price', price);
    formData.append('discount', discount);
    formData.append('type', type);
    formData.append('produced', produced);
    formData.append('category', category);
    formData.append('stock', stock);
    formData.append('weight', weight);
    formData.append('sizes', JSON.stringify(sizes));
    formData.append("tags", JSON.stringify(selectedTags));
    images.forEach((image) => formData.append('images', image));

    try {
      await axios.post('https://api.alyonatestsite.store/api/products', formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      fetchProducts();
      notify({
        title: "Успешно",
        message: `Товар был успешно добавлен.`,
        type: "success",
      });
      navigate('/dashboard/products')
    } catch (error) {
      console.error('Ошибка добавления товара:', error);
    }
  };


  const addSize = () => {
    setSizes([...sizes, { name: '', quantity: 0 }]);
  };

  const removeSize = (index) => {
    setSizes(sizes.filter((_, i) => i !== index));
  };

  const updateSize = (index, field, value) => {
    const updatedSizes = [...sizes];
    updatedSizes[index][field] = value;
    setSizes(updatedSizes);
  };

  const handleMouseMove = (e) => {
    const now = Date.now();
    if (now - lastMoveTime.current < 100) return;
    lastMoveTime.current = now;

    const { left, width } = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - left;
    const partWidth = width / images.length;
    const index = Math.floor(x / partWidth);

    setCurrentImageIndex(index);
  };

  return (
    <section className="bg-white">
      <Header fixed={false} />

      <div className='p-8 w-full flex flex-row space-x-16'>
        <div className='w-1/2'>
        <div className='flex flex-row space-x-4 items-center mb-4'>
          <button className='py-2 px-6 bg-blue-500 text-white w-fit rounded'
            onClick={() => navigate('/dashboard')}>
            Назад в ПУ
          </button> 
          <h1 className="text-3xl font-bold">Создание товара</h1>
        </div>
        <div className="flex flex-col">
        <p className='font-bold text-md'>
            Название
          </p>
          <input
            type="text"
            className="p-2 mt-1 border rounded"
            value={productName}
            onChange={(e) => setProductName(e.target.value)}
          />
          <p className='font-bold text-md mt-4'>
            Описание
          </p>
          <textarea
            className="p-2 mt-1 border rounded"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          ></textarea>
          <p className='font-bold text-md mt-4'>
            Артикул
          </p>
          <input
            type="text"
            className="p-2 mt-1 border rounded"
            value={sku}
            onChange={(e) => setSku(e.target.value)}
          />
          <p className='font-bold text-md mt-4'>
            Цена
          </p>
          <input
            type="number"
            className="p-2 mt-1 border rounded"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
          <p className='font-bold text-md mt-4'>
            Новая цена (скидка) в рублях (если её нет, укажи 0)
          </p>
          <input
            type="number"
            className="p-2 mt-1 border rounded"
            value={discount}
            onChange={(e) => setDiscount(e.target.value)}
          />
          <p className='font-bold text-md mt-4'>
            Состав
          </p>
          <input
            type="text"
            className="p-2 mt-1 border rounded"
            value={produced}
            onChange={(e) => setProduced(e.target.value)}
          />
          <p className='font-bold text-md mt-4'>
            Категория
          </p>
          <select
          className="p-2 mt-1 border rounded"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
              >
                <option value="">Выберите категорию...</option>
                <option value="clothes">Одежда</option>
                <option value="accessories">Аксессуары</option>
                <option value="other">Прочее</option>
          </select>
          <p className='font-bold text-md mt-4'>
            Вес в КГ
          </p>
          <input
            type="number"
            className="p-2 mt-1 border rounded"
            value={weight}
            onChange={(e) => setWeight(e.target.value)}
          />
          <div>
            <h2 className="font-bold mt-4">Размеры</h2>
            {sizes.map((size, index) => (
              <div key={index} className="flex items-center gap-2 mb-2">
                <input
                  type="text"
                  className="p-2 border rounded w-1/3"
                  placeholder="Название размера"
                  value={size.name}
                  onChange={(e) => updateSize(index, 'name', e.target.value)}
                />
                <input
                  type="number"
                  className="p-2 border rounded w-1/3"
                  placeholder="Количество"
                  value={size.quantity}
                  onChange={(e) => updateSize(index, 'quantity', e.target.value)}
                />
                <button
                  onClick={() => removeSize(index)}
                  className="bg-red-500 text-white px-3 py-2 rounded"
                >
                  ✕
                </button>
              </div>
            ))}
            <button
              onClick={addSize}
              className="bg-gray-200 px-4 py-2 rounded"
            >
              Добавить размер
            </button>
          </div>
          <p className='font-bold text-md mt-4'>
            Количество товара (заполнить если нет размеров)
          </p>
          <input
            type="number"
            className="p-2 mt-1 border rounded"
            disabled={sizes.length > 0}
            value={stock}
            onChange={(e) => setStock(e.target.value)}
          />
          <div>
            <h2 className="font-bold mt-4">Теги</h2>
            <div className="flex flex-wrap gap-2">
              {tags.map((tag) => (
                <button
                  key={tag.name}
                  className={`px-4 py-1 rounded-2xl text-white font-bold font-crooker`}
                  style={{
                    backgroundColor: `#${tag.color}`,
                    opacity: selectedTags.some((t) => t.name === tag.name)
                      ? 0.5
                      : 1,
                  }}
                  onClick={() => handleTagClick(tag)}
                >
                  {tag.name}
                </button>
              ))}
            </div>
            <div className="mt-4">
              <h3 className="font-bold">Выбранные теги:</h3>
              <div className="mt-2 flex flex-wrap gap-2">
                {selectedTags.map((tag) => (
                  <span
                    key={tag.name}
                    className={`px-4 py-1 rounded-2xl text-white font-bold font-crooker`}
                    style={{ backgroundColor: `#${tag.color}` }}
                  >
                    {tag.name}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <input
            type="file"
            multiple
            className="p-2 border rounded"
            onChange={(e) => setImages([...e.target.files])}
          />
          <button
            onClick={handleAddProduct}
            className="bg-green-500 text-white px-4 py-2 rounded"
          >
            Добавить товар
          </button>
        </div>
      </div>

      <div className='w-1/2'>
  <div
    onMouseEnter={() => setShowDots(true)}
    onMouseLeave={() => setShowDots(false)}
    onMouseMove={handleMouseMove}
    className="relative w-full lg:w-80 xl:w-80 rounded-lg text-left group select-none"
  >
    <div className="relative overflow-hidden">
      {images.length > 0 ? (
        <img
          src={URL.createObjectURL(images[currentImageIndex])}
          alt={productName}
          className={`w-full h-48 md:h-64 mb-3 object-cover transition-opacity duration-200 rounded-xl`}
          loading="lazy"
        />
      ) : (
        <div
        className={`w-full h-48 md:h-64 mb-3 object-cover transition-opacity duration-200 rounded-xl bg-gray-300`}
        />
      )}

      {showDots && images.length > 0 && (
        <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-1 bg-black/50 px-2 py-1 rounded-full">
          {images.map((_, index) => (
            <div
              key={index}
              className={`w-1.5 h-1.5 rounded-full transition-colors ${index === currentImageIndex ? "bg-sky-500" : "bg-gray-400"
                }`}
            />
          ))}
        </div>
      )}
    </div>

    {selectedTags.length > 0 && (
      <div className="absolute top-5 left-5 flex flex-wrap gap-2">
        {selectedTags.map((tag, index) => (
          <span
            key={index}
            style={{ backgroundColor: `#${tag.color}` }}
            className="text-white font-crooker text-sm font-bold px-4 py-1 rounded-2xl"
          >
            {tag.name}
          </span>
        ))}
      </div>
    )}

    <h2 className={`text-base lg:text-xl font-lack`}>{productName}</h2>
    <div className="flex flex-row space-x-2">
      <p className={`${Number(discount) === 0 ? "text-gray-600" : "text-sky-600 font-bold"}`}>
        {Number(discount) === 0 ? price : discount} ₽
      </p>
      <p className={`${Number(discount) === 0 && "hidden"} text-gray-800 line-through`}>
        {price} ₽
      </p>
    </div>
  </div>
      </div>

      </div>
    </section>
  );
};
